import { compose } from 'redux';
import { connect } from 'react-redux';
import { narrateScreen, selectPracticeScreenResponse, handleOnNext } from './WRPracticeActions';
import { WR_PRACTICE_POST_AUDIO_CALLBACK } from './WRPracticeAvatarActions';
import MultiChoiceQuestionView from '../../../common/questions/multiChoiceQuestionView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import { ACCURACY } from '../../../constants/measure';
import { PRACTICE } from '../../../constants/assessmentItemType';
import selectors from '../../../rootSelectors';
import { fetchWRContent } from '../../wrActions';
import WR_AUDIO_INSTRUCTIONS from '../../wrConstants';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const mapStateToProps = state => ({
    ...multiChoiceUtils.mapStateToProps(state),
    // TODO so far let it be RCT layout
    pageLayout: `${'rct'}-${ACCURACY} ${PRACTICE}`,
    isDataFetched: selectors.getIsWRDataFetched(state),
    possibleResponses: selectors.getWRPossibleResponses(state, PRACTICE),
    stimulusAudio: selectors.getWRStimulusAudio(state, PRACTICE),
});

const mapDispatchToProps = dispatch => ({
    ...multiChoiceUtils.mapDispatchToProps(dispatch),
    onNext: () => {
        dispatch(handleOnNext());
    },
    narrateScreen: stimulusAudio => {
        dispatch(narrateScreen(stimulusAudio));
    },
    selectResponse: index => {
        dispatch(selectPracticeScreenResponse(index));
    },
    fetchContent: () => {
        dispatch(fetchWRContent());
    },
});

const avatarMapStateToProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        animateAlex: true,
        position,
        instructions: WR_AUDIO_INSTRUCTIONS.avatarStart,
        postAudioCallback: WR_PRACTICE_POST_AUDIO_CALLBACK,
    };
};

const WRPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MultiChoiceQuestionView);

export default WRPracticeContainer;
